import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { StoreContext } from '../../../components/App'

import { Link } from 'react-router-dom'
import company_data_intro_splash from '../../../assets/company_data_intro_splash.png'
import {
  Button,
  Container,
  Header,
  Splash,
  SubHeader,
  ToRight,
} from '../EnrollCompany.styles'

export const IntroCompanyData = observer(() => {
  const store = useContext(StoreContext)
  const { theme } = store.AppState
  const {
    enrollCompanyPage: { introCompanyData: trans },
  } = store.TranslationsState.translations

  return (
    <Container>
      <Header>{trans.title}</Header>
      <SubHeader>{trans.subtitle}</SubHeader>
      <Splash src={company_data_intro_splash} alt="" />
      <ToRight>
        <Link to="/enroll-company/company-data">
          <Button type="button">{trans.continue}</Button>
        </Link>
      </ToRight>
    </Container>
  )
})
